<script setup>
import { computed } from "vue";

const props = defineProps({
  modelValue: { type: [Boolean, Array], default: undefined },
  label: { type: [String, Number, Boolean], default: undefined },
  value: { type: [String, Number, Boolean], default: undefined },
  disabled: { type: Boolean, default: false },
  indeterminate: { type: Boolean, default: false },
  size: { type: String, default: "" },
  class: { type: String, default: "" },
});

const emit = defineEmits(["update:modelValue", "change"]);

const model = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});

function onChange(val) {
  emit("change", val);
}
</script>

<template>
  <el-checkbox
    v-model="model"
    :label="label"
    :value="value"
    :disabled="disabled"
    :indeterminate="indeterminate"
    :size="size"
    :class="['shadcn-checkbox', props.class]"
    @change="onChange"
  >
    <slot />
  </el-checkbox>
</template>

<style scoped>
.shadcn-checkbox :deep(.el-checkbox__inner) {
  width: 16px;
  height: 16px;
  border: 1px solid hsl(var(--border));
  border-radius: calc(var(--radius) - 4px);
  background: hsl(var(--background));
  transition: all 0.15s ease;
}

.shadcn-checkbox :deep(.el-checkbox__inner:hover) {
  border-color: hsl(var(--foreground));
}

.shadcn-checkbox :deep(.el-checkbox__input.is-checked .el-checkbox__inner),
.shadcn-checkbox
  :deep(.el-checkbox__input.is-indeterminate .el-checkbox__inner) {
  background-color: hsl(var(--foreground));
  border-color: hsl(var(--foreground));
}

.shadcn-checkbox
  :deep(.el-checkbox__input.is-checked .el-checkbox__inner::after) {
  border-color: hsl(var(--muted));
}

.shadcn-checkbox :deep(.el-checkbox__label) {
  color: hsl(var(--foreground));
  font-size: 14px;
  font-weight: 500;
}

.shadcn-checkbox :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
  color: hsl(var(--foreground));
}

.shadcn-checkbox :deep(.el-checkbox__input.is-focus .el-checkbox__inner) {
  border-color: hsl(var(--foreground));
  box-shadow: 0 0 0 2px hsl(var(--foreground) / 0.2);
}

.shadcn-checkbox :deep(.el-checkbox__input.is-disabled .el-checkbox__inner) {
  background-color: hsl(var(--muted));
  border-color: hsl(var(--border));
  cursor: not-allowed;
}

.shadcn-checkbox :deep(.el-checkbox__input.is-disabled + .el-checkbox__label) {
  color: hsl(var(--muted-foreground));
}
</style>
